import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api/client";
import type { WeatherResponse } from "@/lib/api/types";

export const weatherKeys = {
  all: ["weather"] as const,
};

export function useWeather() {
  return useQuery<WeatherResponse>({
    queryKey: weatherKeys.all,
    queryFn: () => apiFetch<WeatherResponse>("/api/weather"),
    staleTime: 25 * 60_000,
    refetchInterval: 30 * 60_000,
    retry: 1,
  });
}
